export default Object.freeze({
  // 本番
  yumenaviinfo: "https://yumenavi.info/",
  telemail: "https://telemail.jp/",
  apiyumenaviinfo: "https://api.yumenavi.info/lecture/genko/",
  // 保守
  // yumenaviinfo: "https://test.yumenavi.info/",
  // telemail: "https://test.telemail.jp/",
  // apiyumenaviinfo: "https://test-api.yumenavi.info/lecture/genko/",
  // ローカルダミーAPI
  // apiyumenaviinfo: "http://localhost:3100/",
  // ローカルデバッグ実行API
  // apiyumenaviinfo: "http://localhost:59822/lecture/genko/",
});
